<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version || labelText)) {
    <label>
      {{question?.question_copy || question?.email_version || labelText}}
    </label>
  }



  @if (showNoteText) {
    <app-highlight-message
      variant="info"
      icon="info"
      [message]="noteText"
      additionalClasses="mt-15 mb-15">
    </app-highlight-message>
  }

  @if (showUploadLabelText) {
    <div class="custom-upload__label">
      <small [innerHTML]="uploadLabelText"></small>
    </div>
  }
  <div
    class="custom-upload dz-clickable"
    [id]="uniqueId"
    [ngClass]="uploaderType === QuestionTypes.upload_documents ? 'custom-upload--docs' : 'custom-upload--media'">
    <div class="custom-upload__dropzone dz-default">
      <div class="custom-upload__thumb">
        <img [src]="thumbPath" alt="">
      </div>
      <div class="custom-upload__instructions">
        <p>Tap to add files</p>
        <svg class="icon">
          <use xlink:href="#upload"></use>
        </svg>
        <p>Drag & drop files here or <strong>browse</strong>
      </p>
    </div>
  </div>
</div>
<a href="" id="fake"></a>
</div>
